import type { SxProps, Theme } from "@mui/material/styles";

export const roleplayPhoneLandscapeQuery =
  "(orientation: landscape) and (max-height: 500px) and (pointer: coarse)";

export const dialogPaperStyles: SxProps<Theme> = (theme) => ({
  height: "80vh",
  maxHeight: 800,
  backgroundColor:
    theme.palette.mode === "dark" ? "#05070B" : theme.palette.grey[100],
});

export const roleplayFullscreenPaperStyles: SxProps<Theme> = (theme) => ({
  height: "100dvh",
  maxHeight: "100dvh",
  width: "100vw",
  maxWidth: "100vw",
  margin: 0,
  borderRadius: 0,
  display: "flex",
  flexDirection: "column",
  backgroundColor:
    theme.palette.mode === "dark" ? "#05070B" : theme.palette.grey[100],
});

export const roleplayPhoneLandscapePaperStyles: SxProps<Theme> = {
  height: "100dvh",
  maxHeight: "100dvh",
  width: "100vw",
  maxWidth: "100vw",
  margin: 0,
  borderRadius: 0,
  display: "flex",
  flexDirection: "column",
};

export const dialogTitleStyles: SxProps<Theme> = (theme) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor:
    theme.palette.mode === "dark" ? "#05070B" : theme.palette.grey[100],
  color: theme.palette.text.primary,
  // Soft edge instead of a solid full-width rule above the stage cards.
  borderBottom: `1px solid ${
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.06)"
      : "rgba(15, 23, 42, 0.06)"
  }`,
  flexShrink: 0,
});

export const roleplayPhoneLandscapeTitleStyles: SxProps<Theme> = {
  py: 0.25,
  px: 0.75,
  minHeight: 36,
  paddingTop: "max(4px, env(safe-area-inset-top, 0px))",
  paddingLeft: "max(8px, env(safe-area-inset-left, 0px))",
  paddingRight: "max(8px, env(safe-area-inset-right, 0px))",
};

export const dialogTitleTextStyles: SxProps<Theme> = {
  flex: 1,
  fontSize: { xs: "0.875rem", sm: "1rem" },
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  pr: 1,
};

export const closeButtonStyles: SxProps<Theme> = (theme) => ({
  color: theme.palette.text.primary,
  "&:hover": {
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(15, 23, 42, 0.06)",
  },
});

export const roleplayPhoneLandscapeCloseButtonStyles: SxProps<Theme> = {
  p: 0.25,
};

export const dialogContentStyles: SxProps<Theme> = (theme) => ({
  p: 0,
  height: "100%",
  backgroundColor:
    theme.palette.mode === "dark" ? "#05070B" : theme.palette.grey[100],
});

export const roleplayFullscreenContentStyles: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  height: "auto",
  overflow: "hidden",
};

export const roleplayPhoneLandscapeContentStyles: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  height: "auto",
  overflow: "hidden",
  paddingBottom: "env(safe-area-inset-bottom, 0px)",
};

export const contentBoxStyles: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  position: "relative",
};
